export default {
  // SEO
  'about.seo.title': 'Wer sind Andrew & Tristan Tate? | Tate Protest',
  'about.seo.description': 'Ein Überblick über Andrew und Tristan Tate: ihre Hintergründe, die Gerichtsverfahren in Rumänien, im Vereinigten Königreich und in den Vereinigten Staaten sowie die von Unterstützern aufgeworfenen Fragen zu einem ordnungsgemäßen Verfahren und fairer Behandlung.',

  // Hero
  'about.hero.title': 'Wer sind Andrew & Tristan Tate?',
  'about.hero.subtitle': 'Ein Überblick über die Personen, die Gerichtsverfahren und die Beweise rund um eine der umstrittensten internationalen strafrechtlichen Ermittlungen der jüngeren Geschichte.',

  // Profilkarten
  'about.andrew.title': 'Andrew Tate',
  'about.andrew.body': 'Andrew Tate ist ein britisch-amerikanischer Unternehmer, ehemaliger vierfacher Kickbox-Weltmeister und Online-Persönlichkeit. Nach seinem Rücktritt vom Profisport baute er mehrere Unternehmen auf und wurde zu einer der bekanntesten Figuren in den sozialen Medien.',
  'about.tristan.title': 'Tristan Tate',
  'about.tristan.body': 'Tristan Tate ist ein britisch-amerikanischer Unternehmer und ehemaliger Profi-Kickboxer. Er hat bei mehreren Geschäftsvorhaben mit Andrew Tate zusammengearbeitet und tritt häufig in Interviews auf, in denen er über Wirtschaft, Kultur und aktuelle Ereignisse spricht.',
  'about.learnMore': 'Mehr erfahren',

  // Gerichtsverfahren
  'about.legal.title': 'Die Gerichtsverfahren',
  'about.legal.romania': 'Rumänien',
  'about.legal.uk': 'Vereinigtes Königreich',
  'about.legal.us': 'Vereinigte Staaten',
  'about.legal.ro.arrest': 'Festnahme',
  'about.legal.ro.indictment': 'Anklageerhebung',
  'about.legal.ro.appeals': 'Berufungen',
  'about.legal.currentStatus': 'Aktueller Stand',
  'about.legal.uk.charges': 'Strafrechtliche Anklagen',
  'about.legal.uk.extradition': 'Auslieferungsersuchen',
  'about.legal.us.arrest': 'Festnahme in Florida',
  'about.legal.us.federal': 'Bundesverfahren',
  'about.legal.explore': 'Zeitleiste erkunden',

  // Aufgeworfene Fragen
  'about.questions.title': 'Von Unterstützern aufgeworfene Fragen',
  'about.questions.body': 'Unterstützer argumentieren, dass die Ermittlungen Fragen zum ordnungsgemäßen Verfahren, zu langwierigen Gerichtsverfahren, zur Offenlegung von Beweisen, zur Medienberichterstattung und zu politischen Motivationen aufgeworfen haben. Kritiker bestreiten diese Behauptungen und halten daran fest, dass die Vorwürfe vor Gericht geklärt werden sollten. Diese Website dokumentiert öffentlich zugängliche Informationen, damit die Leser das Material prüfen und zu ihren eigenen Schlussfolgerungen gelangen können.',
  'about.questions.viewEvidence': 'Beweise ansehen',

  // Gründer
  'about.founder.label': 'Gegründet von',
  'about.founder.name': 'Wil Pujols',
  'about.founder.before': 'Unternehmer aus Florida und Cousin der MLB-Legende',
  'about.founder.name2': 'Albert Pujols',
  'about.founder.after': '. Wil gründete Tate Protest, um auf die laufenden Gerichtsverfahren aufmerksam zu machen und sich für ein ordnungsgemäßes Verfahren, Transparenz und die faire Behandlung von Andrew und Tristan Tate einzusetzen.',
  'about.founder.learnMore': 'Mehr über Wil',

  // Statistiken
  'about.stats.title': 'Der Fall in Zahlen',
  'about.stats.yearsLabel': 'Jahre unter Ermittlung',
  'about.stats.yearsSubtitle': '2015 bis heute',
  'about.stats.countries': 'Beteiligte Länder',
  'about.stats.hearings': 'Gerichtsanhörungen',
  'about.stats.proceedings': 'Gerichtsverfahren',

  // Handlungsaufforderung
  'about.cta.title': 'Jede Stimme zählt',
  'about.cta.body': 'Schließe dich Tausenden von Menschen auf der ganzen Welt an, die sich für ein ordnungsgemäßes Verfahren und die Menschenrechte einsetzen. Die Tate-Brüder verdienen einen fairen und transparenten Rechtsprozess.',
  'about.cta.faq': 'FAQ lesen',
  'about.cta.getInvolved': 'Mitmachen',
};